import * as Yup from "yup";
import yupValidateInternationalPhoneNumber from "../../../utils/helpers/yupValidateInternationalPhoneNumber";
import { tt } from "../../../utils/i18n/i18n";

const pay_bill_validation_schema = Yup.object({
  shippingAddress: Yup.object({
    name: Yup.string().required(tt("field_required")),
    phoneNumber: Yup.string()
      .required(tt("phone_required"))
      .test(
        "is-valid-phone",
        tt("validPhoneNumberMessage"),
        function (value, { createError }) {
          return yupValidateInternationalPhoneNumber(
            "shippingAddress.phoneNumber",
            value,
            createError
          );
        }
      )
  })
});

export { pay_bill_validation_schema };
